module.exports = {"Guardian":"کنسول حراست","Report":"آخرین تردد ها","Status":"وضعیت دستگاه ها","Live":"نمایش زنده تردد ها"}